<template>
	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-6 is-offset-3">

					<ModalHeaderTitle :title="'Recupera tu contraseña'" />

					<article class="message is-info" v-if="passChanged">
						<div class="message-body">Se cambio tu contraseña exitosamente, ya puedes <router-link to="/jugar">iniciar sesión</router-link> con tu nueva contraseña</div>
					</article>

					<form action="" @submit.prevent="changePass">
						<div class="field">
							<div class="control has-icons-left ">
								<input class="input" :class="errors.email ? 'is-danger' : ''" v-model="email" type="email" placeholder="Ingresa tu email.."/>
								<span class="icon is-small is-left">
									<font-awesome-icon icon="envelope" />
								</span>
							</div>
							<p v-for="(error, key) in errors.email" :key="key" class="help is-danger">
								{{ error }}
							</p>
						</div>
						<div class="field">
							<div class="control has-icons-left">
								<input class="input" :class="errors.password ? 'is-danger' : ''" v-model="password" type="password" placeholder="Ingresa tu nueva contraseña.."/>

								<span class="icon is-small is-left">
									<font-awesome-icon icon="lock" />
								</span>
							</div>
							<p v-for="(error, key) in errors.password" :key="key" class="help is-danger">
								{{ error }}
							</p>
						</div>

						<div class="field">
							<div class="control has-icons-left">
								<input class="input" :class="errors.password_confirmation ? 'is-danger' : ''" v-model="password_confirmation" type="password" placeholder="Confirma tu nueva contraseña.."/>

								<span class="icon is-small is-left">
									<font-awesome-icon icon="lock" />
								</span>
							</div>
							<p v-for="(error, key) in errors.password_confirmation" :key="key" class="help is-danger">
								{{ error }}
							</p>
						</div>
				
						<div class="control">
							<button class="button is-info is-fullwidth" :disabled="passChanged">Cambiar contraseña</button>
						</div>
					</form>
					
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import ModalHeaderTitle from '@/components/ModalHeaderTitle'

	export default {
		components: { ModalHeaderTitle },
		name: 'PassRecover',

		data() {
			return {
				token: '',
				email: '',
				password: '',
				password_confirmation: '',
				errors: [],
				passChanged: false
			};
		},
		mounted(){
			this.token = this.$route.params.token
		},
		methods: {
			changePass(){
				this.$store.dispatch('user/changePass', { 
					token: this.token,
					email: this.email,
					password: this.password,
					password_confirmation: this.password_confirmation 
				})
				.then(resp => {
					if (resp == true) {
						this.passChanged = true
					}
				})
			}
		}
	};
</script>

<style lang="css" scoped>

</style>
